export function buildPublishedViewerUrl(origin: string, hash: string): string {
  const normalizedOrigin = origin.endsWith('/') ? origin.slice(0, -1) : origin;
  return `${normalizedOrigin}/view${hash}`;
}
